<template>
  <authenticated-layout>
    <PageHeader title="Licenses" />
    <access-code-data-table />
  </authenticated-layout>
</template>

<script setup lang="ts">

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import AccessCodeDataTable from "@/components/DataTables/AccessCodeDataTable.vue";
import PageHeader from "@/components/PageHeader.vue";
</script>
